module.exports = __webpack_public_path__ + "assets/retina_CircleTangentLDetailed.39befb64a395393c5913072a6eb7d72e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CircleTangentLDetailed.png
// module id = 648
// module chunks = 0